<template>
  <div class="quote">
    <UiComponentImage
      v-if="quote.logo && quote.logo.src"
      :alt="quote.logo.alt"
      class="logo"
      contains
      :expected-size="28"
      :height="quote.logo.height"
      orientation="portrait"
      :extra-params="{ trim: 'color' }"
      :source="quote.logo.src"
      :width="quote.logo.width"
    />
    <UiComponentParagraph class="content">
      {{ quote.content }}
    </UiComponentParagraph>
    <UiComponentImage
      v-if="quote.customer.avatar && quote.customer.avatar.src"
      :alt="quote.customer.avatar.alt"
      class="avatar"
      :expected-size="48"
      :height="48"
      :source="quote.customer.avatar.src"
      :width="48"
    />
    <UiComponentParagraph
      class="name"
      size="s"
    >
      {{
        quote.customer.name
      }}
    </UiComponentParagraph>
    <UiComponentParagraph
      class="position"
      size="s"
    >
      {{
        quote.customer.position
      }}
    </UiComponentParagraph>
  </div>
</template>

<script setup>
// Props
const props = defineProps({
  quote: {
    required: true,
    type: Object,
  },
})
</script>

<style lang="postcss" scoped>
.quote {
  @apply flex flex-col flex-wrap justify-center items-center w-full py-20;

  .logo {
    @apply h-7 w-full rounded-none;
  }

  .content {
    @apply max-w-xl mt-8 text-grey-blue-600 text-center px-5;

    @screen md {
      @apply px-0;
    }
  }

  .avatar {
    @apply w-12 h-12 mt-8 rounded-full overflow-hidden;
  }

  .name {
    @apply font-medium text-sm text-winter-green-900 leading-6 mt-3 normal-case;
  }

  .position {
    @apply mt-0 text-sm text-grey-blue-600 leading-6 normal-case;
  }
}
</style>
